export default [
  { name: '中山直美', imgSrc: '', subTitle: '', section: 'section1', svgSrc: '', offset: 0 },
  { name: '直址核心', imgSrc: '', subTitle: '', section: 'section3', svgSrc: '', mobileOffset: 0 },
  { name: '上質生活', imgSrc: '', subTitle: '', section: 'section5', svgSrc: '', mobileOffset: 0 },
  { name: '三捷直暢', imgSrc: '', subTitle: '', section: 'section9', svgSrc: '', mobileOffset: 0 },
  { name: '建築直賞', imgSrc: '', subTitle: '', section: 'section10', svgSrc: '', mobileOffset: 0 },
  { name: '精質品牌', imgSrc: '', subTitle: '', section: 'section11', svgSrc: '', mobileOffset: 0 },
  { name: '立即預約', imgSrc: '', subTitle: '', section: 'contact', svgSrc: '', mobileOffset: 0 },
]
